// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + (chunkId === 945 ? "dashboard" : chunkId) + "." + {"39":"2f6f7f37","133":"e0315c27","247":"f3e27014","663":"9fd97ccd","945":"cd76b25f"}[chunkId] + ".css";
};